import { BUILTIN_IOS_APPS } from "./builtinIosApps";
import TriStateControl from "./TriStateControl";

const OPTION_FIELDS = [
  { key: "DisableTouch", label: "Touch deaktivieren" },
  { key: "DisableDeviceRotation", label: "Drehung deaktivieren" },
  { key: "DisableVolumeButtons", label: "Lautstärketasten deaktivieren" },
  { key: "DisableRingerSwitch", label: "Klingelschalter deaktivieren" },
  { key: "DisableSleepWakeButton", label: "Seitentaste deaktivieren" },
  { key: "DisableAutoLock", label: "Auto-Sperre deaktivieren" },
  { key: "EnableVoiceOver", label: "VoiceOver einschalten" },
  { key: "EnableZoom", label: "Zoom einschalten" },
  { key: "EnableAssistiveTouch", label: "AssistiveTouch einschalten" },
];

export default function AppLockEditor({ fields, onChange, disabled }) {
  const app = fields?.App && typeof fields.App === "object" ? fields.App : {};
  const options = app.Options && typeof app.Options === "object" ? app.Options : {};
  const identifier = app.Identifier || fields?.Identifier || "";

  const patchApp = (partial, optionPatch) => {
    const nextOptions = { ...options, ...optionPatch };
    const cleaned = {};
    for (const [key, value] of Object.entries(nextOptions)) {
      if (value !== undefined) cleaned[key] = value;
    }
    onChange({
      ...fields,
      Identifier: undefined,
      App: {
        Identifier: partial.Identifier !== undefined ? partial.Identifier : identifier,
        ...(Object.keys(cleaned).length ? { Options: cleaned } : {}),
      },
    });
  };

  return (
    <div className="row g-3">
      <div className="col-md-8">
        <label className="form-label">App (Bundle-ID)</label>
        <input
          className="form-control"
          list="xavier-app-lock-apps"
          disabled={disabled}
          value={identifier}
          onChange={(e) => patchApp({ Identifier: e.target.value })}
        />
        <datalist id="xavier-app-lock-apps">
          {BUILTIN_IOS_APPS.map((item) => (
            <option key={item.bundleId} value={item.bundleId}>{item.name}</option>
          ))}
        </datalist>
        <div className="form-text">Single App Mode. Die App muss bereits auf dem Gerät installiert sein.</div>
      </div>
      <div className="col-12 profile-restriction-grid">
        {OPTION_FIELDS.map((field) => (
          <div className="profile-field-row" key={field.key}>
            <span className="profile-field-label">{field.label}</span>
            <TriStateControl
              value={options[field.key]}
              onChange={(value) => patchApp({}, { [field.key]: value })}
              disabled={disabled}
              name={field.label}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
